import type {
    ResolveCommerceShareRequest,
    ResolveCommerceShareResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const resolveCommerceShareOperation = defineCommerceOperation<
    ResolveCommerceShareRequest,
    ResolveCommerceShareResponse
>("commerce.share.resolve");
